import { SMILE9_API_ENDPOINT } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { UtilService } from '../../share/util/util.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';
import { ICardSignin } from './card-signin-if';

@Injectable()
export class CardSigninService {
  controlerName = 'api/Signin';

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
  ) { }

  public getCognitoInfo(data: ICardSignin.GetCognitoInfo): Observable<any> {
    const q: ICardSignin.GetCognitoInfo = {
      felica_id: this.utilServ.uType.checkNull(data.felica_id, 'string'),
    };
    return this.http.request('get',
            SMILE9_API_ENDPOINT +
            `${this.controlerName}/CognitoInfoByFelica?felica_id=${q.felica_id}`);
  }
}
